// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-ee08ab5a] {\n  color: #ed4014;\n}\n.table[data-v-ee08ab5a]  .el-tooltip {\n  white-space: inherit !important;\n}\n.star[data-v-ee08ab5a] .el-rate {\n  line-height: 2.2 !important;\n}\n.table[data-v-ee08ab5a]  el-image__inner,\n.table .el-image__placeholder[data-v-ee08ab5a],\n.table .el-image__error[data-v-ee08ab5a] {\n  width: auto !important;\n}\n.info[data-v-ee08ab5a] {\n  width: 82%;\n}", ""]);
// Exports
module.exports = exports;
